var header_across = jQuery("#header_across");
var main_content = jQuery("#mainContent");
var stickyClass = "stuck";
var stuckHeaderHeight = 85;
var gutter = 20;
var stickyHeight = header_across.height() - stuckHeaderHeight;
var hrHeight = gutter + 2;
var isXS = false;

(function($) {
	// Scroll/sticky functions
	$(window).resize(function() {
		if ($(window).width() > 768) {
			header_across.removeClass(stickyClass);
			stickyHeight = header_across.height() - stuckHeaderHeight;
			isXS = false;
		} else {
			isXS = true;
		}
	});

	$(window).scroll(function() {
		if ($(this).scrollTop() > stickyHeight) {
			header_across.addClass(stickyClass);
			main_content.addClass(stickyClass);
		} else {
			header_across.removeClass(stickyClass);
			main_content.removeClass(stickyClass);
		}
	});
})(jQuery);
